import { Link } from "react-router-dom";
import CareerListItem from "../ListItems/CareerListItem";
import BreadCrumb from "../Controls/BreadCrumb";
import Help from "../Controls/Help";
import { MdAddBox } from "react-icons/md";
import "../../style/scss/form.scss";
import "../../style/scss/CustomButton.scss";
import { useCareersQuery } from "../../query/useCareers";

export default function Careers() {
  const { data, isLoading, isError, error } = useCareersQuery();
  const careers = data?.careers || [];

  return (
    <div className="pagebody">
      <BreadCrumb props={["Careers"]} />
      <div className="tabbody">
        <div className="listTitle">
          <h2>Careers</h2>
          <div className="listTitleIcons">
            <Link to="/careers/0" title="Add career">
              <MdAddBox />
            </Link>
          </div>
        </div>
        <Help id="2137" />
        {isLoading ? <p className="fieldHint">Loading careers…</p> : null}
        {isError ? (
          <p className="fieldHint">{error?.message || "Could not load careers."}</p>
        ) : null}
        {!isLoading && !isError && careers.length === 0 ? (
          <p>
            You have not entered any careers yet.{" "}
            <Link to="/careers/0">Create your first career</Link> so matching can find you.
          </p>
        ) : null}
        {!isLoading && !isError && careers.length > 0 ? (
          <ul className="SkillList">
            {careers.map((career) => (
              <CareerListItem key={career.ID || career.id} career={career} />
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
}
